import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const MAP = {
  live: { label: "Live data", color: "text-emerald-400", dot: "bg-emerald-400" },
  delayed: { label: "Delayed", color: "text-amber-300", dot: "bg-amber-400" },
  stale: { label: "Stale", color: "text-zinc-400", dot: "bg-zinc-500" },
  unavailable: { label: "Unavailable", color: "text-rose-400", dot: "bg-rose-400" },
};

// Pick the freshest indicator that is available.
// Prices (3-min heartbeat) is most representative; markets (10-min) is next.
const CANDIDATES = ["prices", "markets"];

export default function DataFreshness() {
  // Share the same query key as Dashboard. On the dashboard this eliminates a
  // duplicate /dashboard/summary request; on other pages it remains the one
  // lightweight freshness request for the app shell.
  const { data, isError } = useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => (await api.get("/dashboard/summary")).data,
    refetchInterval: 60_000,
  });
  const status = isError
    ? "unavailable"
    : CANDIDATES.map((k) => data?.freshness?.[k]).find(Boolean) ||
      data?.freshness?.traders ||
      "unavailable";
  const state = MAP[status] || MAP.unavailable;

  return (
    <div className="flex items-center gap-1.5 text-[11px]" data-testid="data-freshness">
      <span className={`w-1.5 h-1.5 rounded-full ${state.dot} animate-pulse`} />
      <span className={state.color}>{state.label}</span>
    </div>
  );
}
